import { z } from 'zod';
import { DEFAULT_OPERATION_PERIOD, OPERATION_PERIODS } from '../features/catalog/list/operation-period.ts';
import {
  PRODUCT_FILTER_STATUSES,
  PRODUCT_OPERATIONS,
  PRODUCT_SORTS,
  PRODUCT_STOCK_FILTERS,
} from '../features/catalog/list/product-filters.ts';

export const PRODUCTS_DEFAULTS = {
  status: 'active',
  stock: null,
  categoryId: null,
  optionValueId: null,
  company: null,
  search: null,
  operation: null,
  operationPeriod: DEFAULT_OPERATION_PERIOD,
  operationFrom: null,
  operationTo: null,
  sort: 'created:desc',
  product: null,
  created: null,
} as const;

const productsSearch = z.object({
  status: z.enum(PRODUCT_FILTER_STATUSES).catch(PRODUCTS_DEFAULTS.status).default(PRODUCTS_DEFAULTS.status),
  stock: z.enum(PRODUCT_STOCK_FILTERS).nullable().catch(null).default(PRODUCTS_DEFAULTS.stock),
  categoryId: z.string().nullable().catch(null).default(PRODUCTS_DEFAULTS.categoryId),
  optionValueId: z.uuid().nullable().catch(null).default(PRODUCTS_DEFAULTS.optionValueId),
  company: z.string().max(40).nullable().catch(null).default(PRODUCTS_DEFAULTS.company),
  search: z.string().nullable().catch(null).default(PRODUCTS_DEFAULTS.search),
  operation: z.enum(PRODUCT_OPERATIONS).nullable().catch(null).default(PRODUCTS_DEFAULTS.operation),
  operationPeriod: z
    .enum(OPERATION_PERIODS)
    .catch(PRODUCTS_DEFAULTS.operationPeriod)
    .default(PRODUCTS_DEFAULTS.operationPeriod),
  operationFrom: z.iso.date().nullable().catch(null).default(PRODUCTS_DEFAULTS.operationFrom),
  operationTo: z.iso.date().nullable().catch(null).default(PRODUCTS_DEFAULTS.operationTo),
  sort: z.enum(PRODUCT_SORTS).catch(PRODUCTS_DEFAULTS.sort).default(PRODUCTS_DEFAULTS.sort),
  product: z.uuid().nullable().catch(null).default(PRODUCTS_DEFAULTS.product),
  created: z.uuid().nullable().catch(null).default(PRODUCTS_DEFAULTS.created),
});

export type ProductsSearch = z.infer<typeof productsSearch>;

export const validateProductsSearch = (search: Record<string, unknown>): ProductsSearch =>
  productsSearch.parse(search);
